// extracted by mini-css-extract-plugin
module.exports = {"issue":"IssueItem--issue--_KWJS","issue__heading":"IssueItem--issue__heading--2K6SM"};